import React, { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import styled from "styled-components";
import PlayableMovie from "components/front/project/PlayableMovie";
import SwiperCore, { Lazy, Navigation, Pagination } from "swiper";
import { ImageUrl } from "interfaces/front/business";
import SwiperCss from "components/front/layout/SwiperCss";

SwiperCore.use([Navigation, Pagination, Lazy]);

export type Props = { content: Content };
const MainImageSection: FC<Props> = ({ content: { main_content_images, movie_url } }) => {
  return (
    <Root>
      <PlayableMovie movieUrl={movie_url} isActive={true} size="20%" />
      <SwiperArea mainImages={main_content_images} />
    </Root>
  );
};
export default MainImageSection;

const SwiperArea: FC<{ mainImages: ImageUrl[] }> = ({ mainImages }) => {
  return mainImages.length > 1 ? (
    <StyledSwiper slidesPerView={1} navigation pagination={{ clickable: true }} loop>
      {mainImages.map((mainImage, index) => (
        <SwiperSlide key={index}>
          <Image src={mainImage.url} alt={`メイン画像${index + 1}`} loading="lazy" />
        </SwiperSlide>
      ))}
    </StyledSwiper>
  ) : (
    <Image src={mainImages[0].url} alt={`メイン画像`} loading="lazy" />
  );
};

const Root = styled.section`
  margin-bottom: 92px;
  position: relative;

  @media screen and (max-width: 960px) {
    margin-bottom: 46px;
    padding: 0;
  }
`;

const Image = styled.img`
  width: 100%;
`;

const StyledSwiper = styled(Swiper)`
  ${SwiperCss};
`;

interface Content {
  main_content_images: ImageUrl[];
  movie_url: string;
}
